import { ReactNode } from 'react';

import { Box } from '@mui/material';
import { Navigate } from 'react-router-dom';

import { paths } from '../../utils/navigation';
import { Loader } from '../uiComponents/CommonComponents/Loader';
import { useTicketsAccessStatus } from './useTicketsAccessStatus';

// FindingsSettings/FindingType are sibling routes to Findings (not nested
// under it), so Findings.tsx's own access gate never protects them -- without
// this, a Free/Starter account with no active trial could navigate straight
// to /issues/settings or /issues/types/:typeId and read/write Firestore's
// finding_types collection directly. Redirects to the main Tickets route,
// which renders the trial/upgrade landing for a blocked account.
export function TicketsAccessRouteGuard({ children }: { children: ReactNode }) {
  const { access, checked } = useTicketsAccessStatus();

  if (!checked) {
    return (
      <Box data-testid='tickets-guard-loading'>
        <Loader />
      </Box>
    );
  }
  // Allow-list: any access value that isn't explicitly a granted one redirects,
  // so an unknown/renamed backend state can't leave these routes open.
  if (access !== 'full' && access !== 'trial_active') {
    return (
      <Navigate
        to={paths.findings.index}
        replace
      />
    );
  }

  return <>{children}</>;
}
